import './App.css';
import { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Aos from "aos";
import Navbar from './components/Navbar/Navbar';
import About from './pages/Landingpage/About';
import Work from './pages/WorkExperience/Work';
import Projects from './pages/Projects/Projects';
import Achievements from './pages/Achievements/Achievements';
import Research from './pages/Research/Research';
import Education from './pages/Education/Education';
import Contact from './pages/Contact/Contact';
import Headroom from 'react-headroom';
function App() {
  useEffect(() => {
    Aos.init({ duration: 2000, once: true });
  }, []);
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/" exact element={<><Headroom><Navbar /></Headroom><About /></>} />
          {/* <Route path="/Work" exact element={<><Headroom><Navbar /></Headroom><Work /></>} />
          <Route path="/Projects" exact element={<><Headroom><Navbar /></Headroom><Projects /></>} />
          <Route path="/Achievements" exact element={<><Headroom><Navbar /></Headroom><Achievements /></>} />
          <Route path="/Research" exact element={<><Headroom><Navbar /></Headroom><Research /></>} />
          <Route path="/Education" exact element={<><Headroom><Navbar /></Headroom><Education /></>} />
          <Route path="/contact-sanika" exact element={<><Headroom><Navbar /></Headroom><Contact /></>} /> */}
        </Routes>
      </Router>
    </div>
  );
}

export default App;
